import { Component, ChangeDetectionStrategy } from "@angular/core";
import { Router } from "@angular/router";
import { ActivatedRoute } from "@angular/router";
import { MatDialog } from "@angular/material/dialog";

import { AbstractUserComponent } from "./user.component";
import { AuthService } from "../../service/auth.service";
import { AnalyticsService } from "../../service/analytics.service";
import { GeneralService } from "../../service/general.service";


@Component({
    template: "",
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export abstract class AbstractSellerComponent extends AbstractUserComponent {
    constructor(
        router: Router,
        route: ActivatedRoute,
        dialog: MatDialog,
        authService: AuthService,
        analyticsService: AnalyticsService,
        generalService: GeneralService
    ) {
        super(router, route, dialog, analyticsService, generalService, authService);
        this.initPromises.push(
            this.reloadUser()
                .then(u => {
                    if (!u.isSupplier) {
                        this.authService.logout();
                        this.router.navigate(["/user/login"]);
                    }
                    if (u.company == null) {
                        this.router.navigate(["/seller/my-account/onboarding"]);
                    }
                    if (u.company != null && this.router.url == "/seller/my-account/onboarding") {
                        this.router.navigate(["/seller/home"]);
                    }
                })
        );
    }

    ngOnInit(): void {
        super.ngOnInit();
    }
}